import { withNavigation }           from 'components/App/withNavigation';
import { WithNavigationProps }      from 'components/App/withNavigation';
import React                        from 'react';
import { observer }                 from 'mobx-react';
import { EditOutlined }             from '@ant-design/icons';
import Row                          from 'components/App/Row';
import { DeleteOutlined }           from '@ant-design/icons';
import { Col }                      from 'antd';
import { Modal }                    from 'antd';
import ProviderModel                from 'models/ProviderModel';
import currentSession               from 'utils/currentSession';
import { messageSuccessIntl }       from 'utils/messageIntl';
import { messageErrorIntl }         from 'utils/messageIntl';
import { formatMessageIntl }        from 'utils/messageIntl';
import ProviderDashboardContactsBox from '../components/ProviderDashboardContactsBox';
import FormattedMessageWrapper      from 'components/App/FormattedMessageWrapper';
import DashboardComponent           from 'components/App/DashboardComponent';
import GridInfo                     from 'components/App/GridInfo';
import DropDownMenu                 from 'components/App/DropDownMenu';
import PageTitle                    from 'components/App/PageTitle';
import rights                       from 'utils/rights';
import { AppForm }                  from 'components/App/AppForm';
import ProviderForm                 from 'forms/ProviderForm';

const LogoStyle = {
  backgroundPosition: 'center',
  backgroundSize: '100% auto',
  height: '300px',
  overflow: 'hidden',
  width: '300px',
};

@observer
class ProviderDashboard extends React.Component<WithNavigationProps> {
  public provider = new ProviderModel();

  public componentDidMount() {
    if (!currentSession.isAdmin) {
      this.props.navigate('/404');
      return;
    }

    this.fetchData();
  }

  public render() {
    return (
      <>
        <PageTitle title={<FormattedMessageWrapper id="Tableau de bord du prestataire" />} />

        <DashboardComponent
          body={this.renderBody()}
          dataLoading={false}
          headContent={this.renderHeadContent()}
          model={this.provider}
          title={this.renderTitle()}
          topRightComponent={this.renderTopRightComponent()}
        />
      </>
    );
  }

  public renderBody = () => <ProviderDashboardContactsBox provider={this.provider} />;

  public renderHeadContent = () => {
    const data = [
      [
        {
          label: <FormattedMessageWrapper id="Société" />,
          value: '',
        },
        {
          label: <FormattedMessageWrapper id="Lien" />,
          value: this.provider.link,
        },
      ],
    ];

    return (
      <Row>
        <Col md={12} sm={24}>
          <div
            style={{
              ...LogoStyle,
              backgroundImage: `url(${this.provider.logoObjectUrl})`,
            }}
          />
        </Col>
        <Col md={12} sm={24}>
          <GridInfo data={data} />
        </Col>
      </Row>
    );
  };

  public renderTitle = () => this.provider.providerName;

  public renderTopRightComponent = () => {
    const items = [];

    if (rights.for.provider.edit) {
      items.push({
        icon: <EditOutlined />,
        key: 'EDIT',
        label: <FormattedMessageWrapper id="Modifier" />,
        onClick: () =>
          AppForm.open(
            ProviderForm,
            {
              model: this.provider,
              onSuccess: () => this.fetchData(),
            },
            { title: <FormattedMessageWrapper id="Modifier le prestataire" /> },
          ),
      });
    }

    if (rights.for.provider.delete) {
      items.push({
        danger: true,
        icon: <DeleteOutlined />,
        key: 'DELETE',
        label: <FormattedMessageWrapper id="Supprimer" />,
        onClick: () =>
          Modal.confirm({
            cancelText: formatMessageIntl('Annuler'),
            content: formatMessageIntl("Êtes-vous sûr de vouloir supprimer ce prestataire ?"),
            okText: formatMessageIntl('Supprimer le prestataire'),
            okType: 'danger',
            onOk: async () => {
              try {
                await this.provider.destroy();
                messageSuccessIntl('Suppression réussie !');
                this.props.navigate('/prestataires');
              } catch {
                messageErrorIntl('Suppression impossible.');
              }
            },
            title: formatMessageIntl('Supprimer un prestataire'),
          }),
      });
    }

    if (!items.length) {
      return null;
    }

    return <DropDownMenu items={items} />;
  };

  private fetchData = () => {
    const { providerId } = this.props.params;
    this.provider.setId(providerId);
    this.provider.fetch();
  };
}

const WrappedProviderDashboard = withNavigation(ProviderDashboard);

export default WrappedProviderDashboard;
